<template>
    <v-container fluid class="pa-5 pb-16 elevation-1">
        <!-- Encabezado -->
        <v-sheet class="pa-4 w-100" color="#194c9b" elevation="2" rounded>
            <h1 class="text-h4 font-weight-bold d-flex">
                <v-btn icon color="blue">
                    <v-icon>mdi-chart-donut</v-icon>
                </v-btn>
                <span class="ml-2">Dashboard de Consumo Modelos</span>
                <!-- <v-btn :disabled="loading" class="btn-refresh pa-2 ml-auto" @click="cargarDatos"> {{ loading ? "Actualizando..." : "Actualizar" }} </v-btn> -->
            </h1>
        </v-sheet>

        <!-- Filtros -->
        <v-row class="mt-2" dense align="center">
            <v-col cols="6" sm="3" md="2">
                <v-select v-model="anio" :items="anios" label="Año" density="compact" variant="outlined" hide-details
                    @update:modelValue="cargarDatos" />
            </v-col>
            <v-col cols="6" sm="3" md="2">
                <v-select v-model="mes" :items="meses" item-title="title" item-value="value" label="Mes"
                    density="compact" variant="outlined" hide-details @update:modelValue="cargarDatos" />
            </v-col>
            <v-col cols="12" sm="3" md="2">
                <v-btn :loading="loading" color="primary" variant="tonal" prepend-icon="mdi-refresh" block
                    @click="cargarDatos">
                    Actualizar
                </v-btn>
            </v-col>
        </v-row>

        <!-- Error -->
        <v-alert v-if="error" type="error" variant="tonal" class="mt-4">
            {{ error }}
        </v-alert>

        <!-- Loader -->
        <div v-if="loading" class="loader mt-6">
            <v-progress-circular indeterminate color="primary" />
            <div class="mt-2 text-medium-emphasis">Cargando información de consumo…</div>
        </div>

        <template v-else>
            <v-tabs v-model="tab" color="primary" class="mt-2">
                <v-tab value="resumen">Resumen</v-tab>
                <v-tab value="usuario">Por usuario</v-tab>
            </v-tabs>
            <v-divider></v-divider>

            <v-window
                v-model="tab"
                class="mt-3"
                :touch="false"
                :transition="false"
                :reverse-transition="false"
            >
                <!-- ===== TAB RESUMEN ===== -->
                <v-window-item value="resumen">
                    <!-- KPIs -->
                    <v-row class="mt-3" dense>
                        <v-col cols="12" sm="6" md="3">
                            <v-card class="kpi-card" variant="flat" rounded="lg">
                                <div class="kpi-label">Total gastado</div>
                                <div class="kpi-value">{{ money(totalGastado) }}</div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-card class="kpi-card" variant="flat" rounded="lg">
                                <div class="kpi-label">Unidades</div>
                                <div class="kpi-value">{{ nUnidades }}</div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-card class="kpi-card" variant="flat" rounded="lg">
                                <div class="kpi-label">Proyectos</div>
                                <div class="kpi-value">{{ nProyectos }}</div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-card class="kpi-card" variant="flat" rounded="lg">
                                <div class="kpi-label">Equipos</div>
                                <div class="kpi-value">{{ nEquipos }}</div>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!-- Sin datos -->
                    <v-alert v-if="!hayDatos" type="info" variant="tonal" class="mt-4">
                        Aún no hay datos de consumo para mostrar.
                    </v-alert>

                    <!-- Gráficos -->
                    <v-row v-else class="mt-2" dense>
                        <!-- Tendencia por mes -->
                        <v-col cols="12" md="7">
                            <v-card variant="outlined" rounded="lg" class="pa-4 h-100">
                                <div class="chart-title">Consumo por mes</div>
                                <VueApexCharts type="area" height="300" :options="mesOptions" :series="mesSeries" />
                            </v-card>
                        </v-col>

                        <!-- Distribución por equipo -->
                        <v-col cols="12" md="5">
                            <v-card variant="outlined" rounded="lg" class="pa-4 h-100">
                                <div class="d-flex align-center justify-space-between mb-1">
                                    <div class="chart-title" style="margin-bottom: 0">Consumo por equipo</div>
                                    <v-btn-toggle v-model="vista.equipo" density="compact" mandatory variant="outlined"
                                        divided>
                                        <v-btn value="grafico" size="small"><v-icon>mdi-chart-donut</v-icon></v-btn>
                                        <v-btn value="tabla" size="small"><v-icon>mdi-table</v-icon></v-btn>
                                    </v-btn-toggle>
                                </div>
                                <VueApexCharts v-if="vista.equipo === 'grafico'" type="donut" height="300"
                                    :options="equipoOptions" :series="equipoSeries" />
                                <v-data-table v-else v-model="equiposSel" :headers="headersEquipo" :items="tablaEquipo"
                                    :search="searchEquipo" item-value="label" show-select density="compact"
                                    :items-per-page="8">
                                    <template #top>
                                        <v-text-field v-model="searchEquipo" label="Buscar" density="compact"
                                            variant="outlined" hide-details prepend-inner-icon="mdi-magnify"
                                            class="mb-2" />
                                    </template>
                                    <template #[`item.costo`]="{ item }">{{ money(item.costo) }}</template>
                                    <template #[`item.pct`]="{ item }">{{ item.pct.toFixed(1) }}%</template>
                                </v-data-table>
                            </v-card>
                        </v-col>

                        <!-- Por unidad de negocio -->
                        <v-col cols="12" md="6">
                            <v-card variant="outlined" rounded="lg" class="pa-4 h-100">
                                <div class="d-flex align-center justify-space-between mb-1">
                                    <div class="chart-title" style="margin-bottom: 0">Consumo por unidad de negocio</div>
                                    <v-btn-toggle v-model="vista.unidad" density="compact" mandatory variant="outlined"
                                        divided>
                                        <v-btn value="grafico" size="small"><v-icon>mdi-chart-bar</v-icon></v-btn>
                                        <v-btn value="tabla" size="small"><v-icon>mdi-table</v-icon></v-btn>
                                    </v-btn-toggle>
                                </div>
                                <VueApexCharts v-if="vista.unidad === 'grafico'" type="bar" height="340"
                                    :options="unidadOptions" :series="unidadSeries" />
                                <v-data-table v-else v-model="unidadesSel" :headers="headersUnidad" :items="tablaUnidad"
                                    :search="searchUnidad" item-value="label" show-select density="compact"
                                    :items-per-page="8">
                                    <template #top>
                                        <v-text-field v-model="searchUnidad" label="Buscar" density="compact"
                                            variant="outlined" hide-details prepend-inner-icon="mdi-magnify"
                                            class="mb-2" />
                                    </template>
                                    <template #[`item.costo`]="{ item }">{{ money(item.costo) }}</template>
                                    <template #[`item.pct`]="{ item }">{{ item.pct.toFixed(1) }}%</template>
                                </v-data-table>
                            </v-card>
                        </v-col>

                        <!-- Por proyecto -->
                        <v-col cols="12" md="6">
                            <v-card variant="outlined" rounded="lg" class="pa-4 h-100">
                                <div class="d-flex align-center justify-space-between mb-1">
                                    <div class="chart-title" style="margin-bottom: 0">Top proyectos por consumo</div>
                                    <v-btn-toggle v-model="vista.proyecto" density="compact" mandatory
                                        variant="outlined" divided>
                                        <v-btn value="grafico" size="small"><v-icon>mdi-chart-bar</v-icon></v-btn>
                                        <v-btn value="tabla" size="small"><v-icon>mdi-table</v-icon></v-btn>
                                    </v-btn-toggle>
                                </div>
                                <VueApexCharts v-if="vista.proyecto === 'grafico'" type="bar" height="340"
                                    :options="proyectoOptions" :series="proyectoSeries" />
                                <v-data-table v-else v-model="proyectosSel" :headers="headersProyecto"
                                    :items="tablaProyecto" :search="searchProyecto" item-value="label" show-select
                                    density="compact" :items-per-page="8">
                                    <template #top>
                                        <v-text-field v-model="searchProyecto" label="Buscar" density="compact"
                                            variant="outlined" hide-details prepend-inner-icon="mdi-magnify"
                                            class="mb-2" />
                                    </template>
                                    <template #[`item.costo`]="{ item }">{{ money(item.costo) }}</template>
                                    <template #[`item.pct`]="{ item }">{{ item.pct.toFixed(1) }}%</template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-window-item>

                <!-- ===== TAB POR USUARIO ===== -->
                <v-window-item value="usuario">
                    <v-alert v-if="!rowsUsuario.length" type="info" variant="tonal" class="mt-4">
                        No hay datos de usuarios para este periodo.
                    </v-alert>

                    <!-- Tabla para elegir usuarios a comparar -->
                    <v-card v-if="rowsUsuario.length" variant="outlined" rounded="lg" class="mt-1">
                        <v-data-table v-model="usuariosSel" :headers="usuarioHeaders" :items="rowsUsuarioTabla"
                            :search="search" item-value="label" show-select density="compact" :items-per-page="10">
                            <template #top>
                                <v-text-field v-model="search" label="Buscar usuario" density="compact"
                                    variant="outlined" hide-details prepend-inner-icon="mdi-magnify" class="ma-3" />
                            </template>
                            <template #[`item.costo`]="{ item }">{{ money(item.costo) }}</template>
                            <template #[`item.pct`]="{ item }">{{ item.pct.toFixed(1) }}%</template>
                        </v-data-table>
                    </v-card>

                    <template v-if="rowsUsuario.length">
                        <!-- Detalle general de la selección -->
                        <v-row class="mt-1" dense>
                            <v-col cols="12" sm="4">
                                <v-card class="kpi-card" variant="flat" rounded="lg">
                                    <div class="kpi-label">
                                        {{ usuariosSel.length ? "Usuarios seleccionados" : "Usuarios (todos)" }}
                                    </div>
                                    <div class="kpi-value">
                                        {{ usuariosSel.length || rowsUsuario.length }}
                                    </div>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-card class="kpi-card" variant="flat" rounded="lg">
                                    <div class="kpi-label">Gastado (selección)</div>
                                    <div class="kpi-value">{{ money(costoSeleccion) }}</div>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-card class="kpi-card" variant="flat" rounded="lg">
                                    <div class="kpi-label">% del total</div>
                                    <div class="kpi-value">{{ pctSeleccion }}%</div>
                                </v-card>
                            </v-col>
                        </v-row>

                        <!-- Comparación de usuarios -->
                        <v-card variant="outlined" rounded="lg" class="pa-4 mt-3">
                            <div class="chart-title">
                                {{ usuariosSel.length ? "Comparación de usuarios" : "Top usuarios por consumo" }}
                            </div>
                            <VueApexCharts type="bar" :height="Math.max(220, rowsComparacion.length * 38)"
                                :options="usuarioOptions" :series="usuarioSeries" />
                        </v-card>
                    </template>
                </v-window-item>
            </v-window>
        </template>
    </v-container>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import VueApexCharts from "vue3-apexcharts";
import { getUsageForEntity } from "@/api/dashboardUsage";

const loading = ref(true);
const error = ref("");
const data = ref({
    por_mes: [],
    por_unidad: [],
    por_proyecto: [],
    por_equipo: [],
    por_usuario: [],
});

// Tab activo del dashboard
const tab = ref("resumen");
// Usuario seleccionado en la pestaña "Por usuario"
const usuariosSel = ref([]);
// Búsqueda de la tabla de usuarios
const search = ref("");
const usuarioHeaders = [
    { title: "Usuario", key: "label" },
    { title: "Unidad", key: "unidad" },
    { title: "Gastado", key: "costo", align: "end" },
    { title: "% del total", key: "pct", align: "end" },
];

// --- Filtros año / mes ---
const anioActual = new Date().getFullYear();
const anio = ref(anioActual);
const mes = ref(null); // null = todo el año
const anios = [anioActual, anioActual - 1, anioActual - 2];
const meses = [
    { title: "Todo el año", value: null },
    { title: "Enero", value: 1 },
    { title: "Febrero", value: 2 },
    { title: "Marzo", value: 3 },
    { title: "Abril", value: 4 },
    { title: "Mayo", value: 5 },
    { title: "Junio", value: 6 },
    { title: "Julio", value: 7 },
    { title: "Agosto", value: 8 },
    { title: "Septiembre", value: 9 },
    { title: "Octubre", value: 10 },
    { title: "Noviembre", value: 11 },
    { title: "Diciembre", value: 12 },
];
const NOMBRE_MES = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];


// --- Colores (marca para series de magnitud, categórico CVD-safe para donut) ---
const BLUE = "#005FA9";
// Paleta Okabe-Ito (segura para daltonismo)
const CATEGORICAL = [
    "#0072B2", "#E69F00", "#009E73", "#CC79A7",
    "#56B4E9", "#D55E00", "#F0E442", "#999999",
];

// --- Normalizadores: el backend puede nombrar los campos distinto ---
const COSTO_KEYS = [
    "costo", "cost_usd", "costo_usd", "total_costo", "costo_total",
    "total", "monto", "gasto", "gastado",
];

function etiqueta(item, keys) {
    for (const k of keys) {
        if (item?.[k] != null && item[k] !== "") return String(item[k]);
    }
    const s = item ? Object.values(item).find((v) => typeof v === "string") : null;
    return s != null ? String(s) : "—";
}
function numero(item, keys) {
    for (const k of keys) {
        const v = item?.[k];
        if (v != null && v !== "" && !isNaN(parseFloat(v))) return parseFloat(v);
    }
    return 0;
}
function filas(arr, labelKeys, { top = 0, ordenar = true } = {}) {
    let rows = (arr || []).map((i) => ({
        label: etiqueta(i, labelKeys),
        costo: numero(i, COSTO_KEYS),
    }));
    if (ordenar) rows = [...rows].sort((a, b) => b.costo - a.costo);
    if (top) rows = rows.slice(0, top);
    return rows;
}

// --- Filas por dimensión ---
const rowsMes = computed(() =>
    // cronológico: no reordenar por costo
    filas(data.value.por_mes, ["mes", "periodo", "month", "fecha", "anio_mes"], {
        ordenar: false,
    }),
);
// --- Selección por TABLA (checkboxes) que alimenta cada gráfico ---
const unidadesSel = ref([]);
const equiposSel = ref([]);
const proyectosSel = ref([]);

// Límite de selección: máximo 10 por tabla (incluye usuarios)
const MAX_SEL = 10;
[unidadesSel, equiposSel, proyectosSel, usuariosSel].forEach((sel) => {
    watch(sel, (v) => {
        if (v.length > MAX_SEL) sel.value = v.slice(0, MAX_SEL);
    });
});



// Listas COMPLETAS (base de tablas y gráficos), ordenadas desc por costo
const unidadesRows = computed(() =>
    filas(
        data.value.por_unidad,
        ["unidad", "unidad_negocio", "nombre_unidad", "nombre", "name"],
        {},
    ),
);
const proyectosRows = computed(() =>
    (data.value.por_proyecto || [])
        .map((i) => ({
            label: etiqueta(i, ["proyecto", "nombre_proyecto", "nombre", "clave", "name"]),
            costo: numero(i, COSTO_KEYS),
            unidad: etiqueta(i, [
                "unidad_nombre",
                "unidad",
                "unidad_negocio",
                "nombre_unidad",
            ]),
        }))
        .sort((a, b) => b.costo - a.costo),
);
const equiposRows = computed(() =>
    (data.value.por_equipo || [])
        .map((i) => ({
            label: etiqueta(i, ["equipo", "nombre_equipo", "nombre", "name"]),
            costo: numero(i, COSTO_KEYS),
            unidad: etiqueta(i, ["unidad_nombre",
]),
        }))
        .sort((a, b) => b.costo - a.costo),
);

// Filas del GRÁFICO: lo seleccionado en la tabla, o top N si no hay selección
const rowsUnidad = computed(() =>
    (unidadesSel.value.length
        ? unidadesRows.value.filter((r) => unidadesSel.value.includes(r.label))
        : unidadesRows.value
    ).slice(0, 10),
);
const rowsProyecto = computed(() =>
    (proyectosSel.value.length
        ? proyectosRows.value.filter((r) => proyectosSel.value.includes(r.label))
        : proyectosRows.value
    ).slice(0, 10),
);
const rowsEquipo = computed(() =>
    (equiposSel.value.length
        ? equiposRows.value.filter((r) => equiposSel.value.includes(r.label))
        : equiposRows.value
    ).slice(0, 8),
);

// --- Tablas por dimensión: SIEMPRE todas las filas (con % y checkboxes) ---
function conPct(rows, total) {
    return rows.map((r) => ({ ...r, pct: total ? (r.costo / total) * 100 : 0 }));
}
const tablaUnidad = computed(() =>
    conPct(unidadesRows.value, unidadesRows.value.reduce((s, r) => s + r.costo, 0)),
);
const tablaProyecto = computed(() =>
    conPct(proyectosRows.value, proyectosRows.value.reduce((s, r) => s + r.costo, 0)),
);
const tablaEquipo = computed(() =>
    conPct(equiposRows.value, equiposRows.value.reduce((s, r) => s + r.costo, 0)),
);

// Vista (gráfico/tabla) y búsqueda por dimensión
const vista = ref({ unidad: "grafico", equipo: "grafico", proyecto: "grafico" });
const searchUnidad = ref("");
const searchEquipo = ref("");
const searchProyecto = ref("");
const headersUnidad = [
    { title: "Unidad", key: "label" },
    { title: "Gastado", key: "costo", align: "end" },
    { title: "% del total", key: "pct", align: "end" },
];
const headersEquipo = [
    { title: "Equipo", key: "label" },
    { title: "Unidad", key: "unidad" },
    { title: "Gastado", key: "costo", align: "end" },
    { title: "% del total", key: "pct", align: "end" },
];
const headersProyecto = [
    { title: "Proyecto", key: "label" },
    { title: "Unidad", key: "unidad" },
    { title: "Gastado", key: "costo", align: "end" },
    { title: "% del total", key: "pct", align: "end" },
];
const rowsUsuario = computed(() =>
    (data.value.por_usuario || [])
        .map((i) => ({
            label: etiqueta(i, ["usuario", "nombre", "name", "email", "correo", "user"]),
            costo: numero(i, COSTO_KEYS),
            unidad: etiqueta(i, [
                "unidad_nombre",
                "unidad",
                "unidad_negocio",
                "nombre_unidad",
            ]),
        }))
        .sort((a, b) => b.costo - a.costo),
);

// Total de todos los usuarios (para % de la selección)
const totalUsuarios = computed(() =>
    rowsUsuario.value.reduce((s, r) => s + r.costo, 0),
);

// Usuarios elegidos para comparar (si no hay ninguno, se toma todo)
const rowsSeleccionadas = computed(() =>
    usuariosSel.value.length
        ? rowsUsuario.value.filter((r) => usuariosSel.value.includes(r.label))
        : rowsUsuario.value,
);
const costoSeleccion = computed(() =>
    rowsSeleccionadas.value.reduce((s, r) => s + r.costo, 0),
);
const pctSeleccion = computed(() =>
    totalUsuarios.value
        ? ((costoSeleccion.value / totalUsuarios.value) * 100).toFixed(1)
        : "0.0",
);

// Para el gráfico: top 10 + "Otros" (evita saturar con muchos usuarios).
const TOP_USUARIOS = 10;
const rowsUsuarioChart = computed(() => {
    const all = rowsUsuario.value; // ya viene ordenado desc por costo
    if (all.length <= TOP_USUARIOS) return all;
    const top = all.slice(0, TOP_USUARIOS);
    const restoCosto = all.slice(TOP_USUARIOS).reduce((s, r) => s + r.costo, 0);
    return [...top, { label: `Otros (${all.length - TOP_USUARIOS})`, costo: restoCosto }];
});

// Filas que se grafican: los seleccionados (comparación) o el top 10 por defecto
const rowsComparacion = computed(() =>
    usuariosSel.value.length
        ? rowsUsuario.value.filter((r) => usuariosSel.value.includes(r.label))
        : rowsUsuarioChart.value,
);

// Filas para la tabla de selección (con % por fila)
const rowsUsuarioTabla = computed(() =>
    rowsUsuario.value.map((r) => ({
        ...r,
        pct: totalUsuarios.value ? (r.costo / totalUsuarios.value) * 100 : 0,
    })),
);

// --- KPIs ---
const totalGastado = computed(() => {
    const base = rowsMes.value.length ? rowsMes.value : unidadesRows.value;
    return base.reduce((s, r) => s + r.costo, 0);
});
const nUnidades = computed(() => (data.value.por_unidad || []).length);
const nProyectos = computed(() => (data.value.por_proyecto || []).length);
const nEquipos = computed(() => (data.value.por_equipo || []).length);
const hayDatos = computed(
    () =>
        rowsMes.value.length ||
        nUnidades.value ||
        nProyectos.value ||
        nEquipos.value,
);

// --- Helpers de formato ---
function money(v) {
    return `$${Number(v || 0).toFixed(4)}`;
}

const barBase = {
    chart: { toolbar: { show: false }, fontFamily: "inherit" },
    colors: [BLUE],
    dataLabels: { enabled: false },
    plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: "60%" } },
    grid: { borderColor: "#eef0f4", strokeDashArray: 4 },
    tooltip: { y: { formatter: (v) => money(v) } },
    noData: { text: "Sin datos" },
};

// --- Series + opciones por gráfico ---
const mesSeries = computed(() => [
    { name: "Costo (USD)", data: rowsMes.value.map((r) => +r.costo.toFixed(6)) },
]);
const mesOptions = computed(() => ({
    chart: { toolbar: { show: false }, fontFamily: "inherit", zoom: { enabled: false } },
    colors: [BLUE],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    fill: {
        type: "gradient",
        gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.05 },
    },
    xaxis: {
        categories: rowsMes.value.map((r) => {
            const n = parseInt(r.label, 10);
            return n >= 1 && n <= 12 ? NOMBRE_MES[n - 1] : r.label;
        }),
        axisBorder: { show: false },
        axisTicks: { show: false },
    },
    yaxis: { labels: { formatter: (v) => `$${Number(v).toFixed(2)}` } },
    grid: { borderColor: "#eef0f4", strokeDashArray: 4 },
    tooltip: { y: { formatter: (v) => money(v) } },
    noData: { text: "Sin datos" },
}));

const unidadSeries = computed(() => [
    { name: "Costo (USD)", data: rowsUnidad.value.map((r) => +r.costo.toFixed(6)) },
]);
const unidadOptions = computed(() => ({
    ...barBase,
    xaxis: {
        categories: rowsUnidad.value.map((r) => r.label),
        labels: { formatter: (v) => `$${Number(v).toFixed(2)}` },
    },
}));

const proyectoSeries = computed(() => [
    { name: "Costo (USD)", data: rowsProyecto.value.map((r) => +r.costo.toFixed(6)) },
]);
const proyectoOptions = computed(() => ({
    ...barBase,
    xaxis: {
        categories: rowsProyecto.value.map((r) => r.label),
        labels: { formatter: (v) => `$${Number(v).toFixed(2)}` },
    },
}));

const equipoSeries = computed(() => rowsEquipo.value.map((r) => +r.costo.toFixed(6)));
const equipoOptions = computed(() => ({
    chart: { fontFamily: "inherit" },
    labels: rowsEquipo.value.map((r) => r.label),
    colors: CATEGORICAL,
    legend: { position: "bottom" },
    stroke: { width: 2 },
    dataLabels: { enabled: true, formatter: (val) => `${val.toFixed(1)}%` },
    plotOptions: { pie: { donut: { size: "62%" } } },
    tooltip: { y: { formatter: (v) => money(v) } },
    noData: { text: "Sin datos" },
}));

const usuarioSeries = computed(() => [
    { name: "Costo (USD)", data: rowsComparacion.value.map((r) => +r.costo.toFixed(6)) },
]);
const usuarioOptions = computed(() => ({
    ...barBase,
    xaxis: {
        categories: rowsComparacion.value.map((r) => r.label),
        labels: { formatter: (v) => `$${Number(v).toFixed(2)}` },
    },
}));

// --- Carga ---
async function cargarDatos() {
    loading.value = true;
    error.value = "";
    try {
        // anio siempre; mes solo si se eligió uno (null = todo el año)
        const params = { anio: anio.value };
        if (mes.value) params.mes = mes.value;
        const res = await getUsageForEntity(params);
        data.value = {
            por_mes: res?.por_mes || [],
            por_unidad: res?.por_unidad || [],
            por_proyecto: res?.por_proyecto || [],
            por_equipo: res?.por_equipo || [],
            por_usuario: res?.por_usuario || [],
        };
        console.log("consumo por entidad", res);
    } catch (e) {
        error.value = "No se pudo cargar la información de consumo.";
        console.error(e);
    } finally {
        loading.value = false;
    }
}

onMounted(cargarDatos);
</script>

<style scoped>
.loader {
    text-align: center;
    padding: 40px;
}

.kpi-card {
    background: #d5dce7;
    border: 1px solid #e6eaf1;
    padding: 18px;
}

.kpi-label {
    color: #6b7280;
    font-size: 13px;
    margin-bottom: 6px;
}

.kpi-value {
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
}

.chart-title {
    font-size: 15px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
}
</style>
